export default __webpack_public_path__ + "static/media/favorite.c956edaa.svg";